module.exports = __webpack_public_path__ + "images/no_notifications.b15698002dc47434e0a30acf487185c1.png";